module.exports = __webpack_public_path__ + "img/whiteplus-icon.512c7cae.svg";